import fetchProductsRequest from './fetchProductsRequest';
import filterProducts from './filterProducts';

export default (filteredProducts) => {
    return dispatch => {
        dispatch(fetchProductsRequest());
        return dispatch(filterProducts(filteredProducts));
    }
}
